import React from 'react'

import IconStyle from './Icons.module.scss'

export const ReturnMaoBi = (props: any): React.ReactElement => {
  const { text = '下单返猫币' } = props
  return (
    <span className={IconStyle.gradientOrange}>{text}</span>
  )
}